
import {computed,defineComponent,PropType,ref} from 'vue'
import store from '@/store'
import {pinnedFilterLabels,pinnedFilterValue} from '@/utils/pinnedFilter'
export default defineComponent({
  props:{modelValue:{type:Boolean as PropType<boolean|null>,default:null}},
  emits:['update:modelValue','change'],
  setup(_props,{emit}) {
    const focused=ref(false)
    const text=computed(()=>pinnedFilterLabels(store.state.app.language))
    const change=(event:Event)=>{focused.value=false;const value=pinnedFilterValue((event.target as HTMLSelectElement).value);emit('update:modelValue',value);emit('change',value)}
    return{text,change,focused}
  }
})
